import React from "react";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import {
    IPlatformTransformationAttemptStep,
    PlatformTransformationStepStatus,
} from "../../../../../services/api/admin-migrate-global-e-merchants-service";

interface IPlatformTransformationStepsProps {
    steps: IPlatformTransformationAttemptStep[];
}

function stepColor(status: PlatformTransformationStepStatus): FONT_COLOR {
    if (status === "completed") {
        return FONT_COLOR.SEMANTIC_SUCCESS;
    }
    if (status === "failed") {
        return FONT_COLOR.SEMANTIC_DANGER;
    }
    if (status === "skipped") {
        return FONT_COLOR.ACCENT2;
    }
    return FONT_COLOR.PRIMARY2;
}

function stepStatusText(step: IPlatformTransformationAttemptStep): string {
    if (step.status === "completed") {
        return "completed";
    }
    if (step.status === "skipped") {
        return step.failure_reason ? `skipped — ${step.failure_reason}` : "skipped";
    }
    if (step.status === "failed") {
        return step.failure_reason ? `failed — ${step.failure_reason}` : "failed";
    }
    return "started";
}

const PlatformTransformationSteps: React.FC<IPlatformTransformationStepsProps> = ({ steps }) => {
    if (steps.length === 0) {
        return null;
    }

    return (
        <ul className="platform-transformation-result__steps">
            {steps.map((step) => (
                <li key={`${step.step_name}-${step.created_at ?? ""}`}>
                    <FontBody1 color={stepColor(step.status)}>
                        {step.step_name}: {stepStatusText(step)}
                    </FontBody1>
                </li>
            ))}
        </ul>
    );
};

export default PlatformTransformationSteps;
